import React from 'react';
import SearchDiscoverView from './SearchDiscoverView';

export interface SearchDiscoverRouteProps {
  className?: string;
}

const SearchDiscoverRoute: React.FC<SearchDiscoverRouteProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <SearchDiscoverView />
    </div>
  );
};

export default SearchDiscoverRoute;
